<template>
  <span>
    <b-button variant="edit" @click="showTaskModal(task)" qid="delete-s-cancel-button" v-if="!fromHomepage">
      <span v-if="task">
        <font-awesome-icon icon="pen" />
      </span>
      <span v-if="!task">
        {{ $t('tasks.open_first_task') }}
      </span>
    </b-button>

    <b-button
        v-if="fromHomepage"
        class="icon-btn"
        variant="link"
        @click="showTaskModal(task)"
        qid="delete-s-cancel-button"
        v-b-tooltip.hover
        :title="$t('tasks.open_button')"
    >
      <font-awesome-icon icon="up-right-from-square" />
      <!-- <span v-if="task">
        {{ $t('tasks.open_button') }}
      </span>
      <span v-if="!task">
        {{ $t('tasks.open_first_task') }}
      </span> -->
    </b-button>

    <!-- Engagement tasks open in the task panel; it answers to the same ref as the modal -->
    <EngagementTaskPanel v-if="panel" ref="task-modal" />

    <!-- Task modal -->
    <b-modal v-else ref="task-modal" @hide="hideTaskModal" size="xl" modal-class="task-side-panel task-modal multi-color-modal"
      :no-close-on-backdrop="isControlAssessment">

      <!-- HEADER -->
      <template #modal-header="{ close }" class="alert-menu-color text-white">
        <AssessmentGlobalSingleTaskModalHeader />
      </template>

      <AssessmentGlobalSingleTaskModalBody />

      <!-- FOOTER -->
      <template #modal-footer="{ close }">
        <AssessmentGlobalSingleTaskModalFooter ref="footer" />
      </template>
    </b-modal>

    <AssessmentGlobalSingleTaskModalAuxModals ref="auxModals" />

    <!-- Edit the task itself (US 9398) -->
    <TaskDialog v-if="selectedTask && selectedTask.project"
                ref="taskDialog"
                :adapter="taskAdapter"
                :objectives="projectObjectives"
                :objective-required="isControlAssessment"
                :read-only="taskDialogLock"
                :documentation-locked="isInOeTesting ? $t('task_dialog.locks.oe_testing') : ''"
                @saved="taskEdited"
    ></TaskDialog>

  </span>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import Datepicker from 'vuejs-datepicker';
import { config } from '@/config.js';
import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
import GuideViewModal from '@/components/guide/GuideViewModal.vue';
import roleCheck from '@/util/ACL/roleCheck';
import Avatar from '@/components/Avatar.vue';
import ShowMoreModal from '@/components/ShowMoreModal.vue';
// import draggable from 'vuedraggable'
import CreateObservationModal from '@/views/Projects/CreateObservationModal.vue';
import WordByWord from '@/components/WordByWord.vue';
// import AssessmentGlobalExpandable from '@/components/tasks/AssessmentGlobalExpandable.vue';
import UserInviteModal from '@/components/user/UserInviteModal.vue';
import ObservationViewModal from '@/views/Projects/ObservationViewModal.vue';
import MeasuresTable from '@/views/Projects/MeasuresTable.vue';
import AssessmentGlobalSingleTaskModalHeader from '@/views/Tasks/Assessment/AssessmentGlobalSingleTaskModalHeader.vue';
import AssessmentGlobalSingleTaskModalBody from '@/views/Tasks/Assessment/AssessmentGlobalSingleTaskModalBody.vue';
import AssessmentGlobalSingleTaskModalFooter from '@/views/Tasks/Assessment/AssessmentGlobalSingleTaskModalFooter.vue';
import EngagementTaskPanel from './Assessment/EngagementTaskPanel.vue';
import AssessmentGlobalSingleTaskModalAuxModals from '@/views/Tasks/Assessment/AssessmentGlobalSingleTaskModalAuxModals.vue';
import TaskDialog from '@/components/assessment/TaskDialog.vue';
import { projectAdapter } from '@/components/assessment/taskDialogAdapters.js';

export default {
  name: 'AssessmentGlobalSingleTaskModal',
  data: function () {
    return {
      projectObjectives: [],
      // Update Task variables
      taskForm: {
        remarks: '',
        notes: '',
        data_remarks: '',
        control_description: '',
        performed_text: '',
        testing_notes: '',
        rto: '',
        rpo: ''
      },
      testForm: {
        name: '',
        description: '',
        allow_description: '',
        allow_attachment: '',
        status: '',
        comment: '',
        description_data: ''
      },
      selectedTask: [],
      selectedTest: [],

      // Update Question variables
      form: {
        name: '',
        description: '',
        description_two: '',
        reference: '',
        control_objective: {},
        links: [],
        data_collection_links: [],
        data_collection_description: '',
        data_collection_description_two: ''
      },
      referenceInvalid: false,
      addControlDescription: [],
      addNotes: [],
      addTestingNotes: [],
      addPerformedText: [],
      addDescription: [],
      addResponse: [],
      addAttachments: [],
      data_collection_on: 0,
      responseType: [],
      responseTypeDoc: [],
      addResponseDoc: [],
      dataCollectionAddDescription: [],
      dataCollectionAddAttachments: [],
      showQuestionLinksSection: false,
      showQuestionTwoLinksSection: false,
      selectedTaskDependency: [],

      responseTypes: [
        {
          group: this.$t('maintenance.questions.answer_type.input_label'),
          items: [
            { name: this.$t('maintenance.questions.type.datepicker'), value: 'Datepicker' },
          ]
        },
        {
          group: this.$t('maintenance.questions.answer_type.dropdown_label'),
          items: [
            { name: this.$t('maintenance.questions.type.dropdown'), value: 'Dropdown' },
            { name: this.$t('maintenance.questions.type.yes/no'), value: 'Yes/No' }
          ]
        }
      ],
      allowTypes: [
        { name: this.$t('maintenance.questions.type.no'), value: 'No' },
        { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
        { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
      ],
      allowTypesDoc: [
        { name: this.$t('maintenance.questions.type.no'), value: 'No' },
        { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
        { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
        { name: this.$t('maintenance.questions.type.auditor'), value: 'Auditor' },
      ],
      testStatus: [
        { name: this.$t('testing.status.pending'), value: 'pending' },
        { name: this.$t('testing.status.documentation_collection_completed'), value: 'documentation_collection_completed' },
        { name: this.$t('testing.status.failed'), value: 'failed' },
        { name: this.$t('testing.status.passed'), value: 'passed' },
      ],
      allowTypesShort: [
        { name: this.$t('maintenance.questions.type.optional'), value: 'Optional' },
        { name: this.$t('maintenance.questions.type.mandatory'), value: 'Mandatory' },
      ],
      answerTypes: [
        {
          group: this.$t('maintenance.questions.answer_type.positive_negative_label'),
          items: [
            { name: this.$t('maintenance.questions.answer_type.neutral'), value: 'Neutral' },
            { name: this.$t('maintenance.questions.answer_type.positive'), value: 'Positive' },
            { name: this.$t('maintenance.questions.answer_type.negative'), value: 'Negative' },
          ]
        },
        {
          group: this.$t('maintenance.questions.answer_type.impact_assessment_label'),
          items: [
            { name: this.$t('maintenance.questions.answer_type.very_low'), value: 'Very low' },
            { name: this.$t('maintenance.questions.answer_type.low'), value: 'Low' },
            { name: this.$t('maintenance.questions.answer_type.medium'), value: 'Medium' },
            { name: this.$t('maintenance.questions.answer_type.high'), value: 'High' },
            { name: this.$t('maintenance.questions.answer_type.very_high'), value: 'Very high' },
          ]
        },
      ],
      yesNoOptions: [
        'Yes',
        'No'
      ],
      yesValue: [],
      noValue: [],
      dataCollectionOptions: [
        { text: this.$t('system.yes'), value: 1 },
        { text: this.$t('system.no'), value: 0 },
      ],
      selectedOptions: [],
      inputOption: '',
      positiveAnswers: [],
      negativeAnswers: [],

      // Framework Control variables
      selectedFrameworkControls: [],
      selectedFramework: [],
      selectedFrameworkControl: [],
      frameworkControlItems: [],
      frameworkItems: [],

      // Control Objective variables
      controlObjectives: [],
      selectedControlObjective: {},
      assessmentControlOpen: false,
      coForm: {
        name: '',
        description: ''
      },
      sTableItems: [],
      loadingObservations: true,
      perPage: '',
      selectedPerPage: "10",
      currentPage: 1,
      totalRows: 0,
      selectedObservation: {},
      viewObservationModal: false,
      itemToDelete: {},
      editForm: {
        name: '',
        description: '',
        scope_id: '',
        impact_assessment: ''
      },
      selectedImpact: [],
      scopeItems: [],
      selectedScope: [],
      // General variables
      buttonDisabled: false,
      selectedFile: {},
      selectedLink: {},
      selectedComment: {},
      showDeleteAttachmentModal: false,
      showDeleteLinkedAttachmentModal: false,
      showDeleteLinkModal: false,
      showDeleteCommentModal: false,
      showInput: false,
      showSingleLinkLabel: true,
      inputLink: '',
      inputLinkName: '',
      descriptionLength: config.descriptionLength,
      showFullProjectMessage: false,
      showFullTaskDescription: false,
      showFullDataCollectionDescription: false,
      showFullMainTaskDescriptionOne: false,
      showFullMainTaskDescriptionTwo: false,
      showFullGenericControlDescription: false,
      error: '',
      sizeError: '',
      taskList: [],
      selectedAnswer: [],
      selectedAnswerDoc: [],
      selectedDate: '',
      selectedDateDoc: '',
      selectedDataCollectionAnswer: [],
      allAnswers: [],
      allAnswersDoc: [],
      impactItems: [
        { name: this.$t('impact.very_low'), value: 'Very low' },
        { name: this.$t('impact.low'), value: 'Low' },
        { name: this.$t('impact.high'), value: 'High' },
        { name: this.$t('impact.very_high'), value: 'Very high' }
      ],
      intervalOptions: [
        { text: this.$t('system.interval_seconds'), value: 'Seconds' },
        { text: this.$t('system.interval_minutes'), value: 'Minutes' },
        { text: this.$t('system.interval_hours'), value: 'Hours' },
        { text: this.$t('system.interval_days'), value: 'Days' },
        { text: this.$t('system.interval_months'), value: 'Months' },
        { text: this.$t('system.interval_years'), value: 'Years' },
      ],
      selectedConfidentialityImpact: [],
      selectedIntegrityImpact: [],
      selectedAvailabilityImpact: [],
      rtoInterval: [],
      rpoInterval: [],
      project_progress: 0,
      taskCompleted: false,
      welcomeGuide: {},
      selectedGuide: {},
      viewGuideModal: false,
      selectedItem: {},
      showUsersModal: false,
      currentView: 'default',
      files: [],
      files_two: [],
      data_collection_files: [],
      test_files: [],
      // Engagements: the client's answer on a test is edited and saved on its own
      editModeTestAnswer: false,
      data_collection_two_files: [],
      showLinksSection: false,
      showLinksSectionTwo: false,
      showDataCollectionLinksSection: false,
      uploader: false,
      showDropActive: false,
      userList: [],
      comment: '',
      reopenError: '',
      selectedAssignUsers: [],
      previousComments: [],
      qaComments: [],
      loadingComments: true,
      loadingQaComments: true,
      tests: [],
      loadingTests: true,
      showFullGuideDescription: false,
      wpGuide: {},
      wpGuideData: {},
      wpGuideSystem: {},
      myGuides: [],
      myGuidesData: [],
      myGuidesSystem: [],

      editModeResponse: false,
      editModeResponseDoc: false,
      editModeResponseDocMain: false,
      editModeNotes: false,
      editModeControlDescription: false,
      editModePerformedTest: false,
      editModeTestingNotes: false,
      editModeConclusion: false,
      editModeControlDescriptionDocumentationCollection: false,

      showFullTextNotes: false,
      showFullTextControlDescription: false,
      showFullTextPerformedTest: false,
      showFullTextTestingNotes: false,
      showFullTextConclusion: false,
      showFullTextControlDescriptionDocumentationCollection: false,

      assessmentGlobalExpandableShow: false,
      qa_comment: '',
      linkedControls: [],
      allLinkedMediaFiles: [],
      allLinkedDataMediaFiles: [],
      selectedLinkedMedia: [],
      selectedLinkedDataMedia: [],
      isControlDescriptionDrawerOpen: false,
      isFullAnalystDrawerOpen: false,
      isTestingDrawerOpen: false,
      testPlanAi: [],
      controlDescriptionAi: [],
      fullAnalystAi: [],
      aiUnreadAttachments: [],
      ailoading: false,
      // Task values as last loaded, used to detect edits by another user before saving a field
      conflictBaseline: {
        updatedAt: null,
        fields: {}
      },
      fieldConflict: {
        field: '',
        mine: '',
        theirs: '',
        theirsBy: '',
        theirsAt: '',
        merged: '',
        choice: 'mine',
        editMine: false,
        editMerged: false,
        mergeLoading: false,
        mergeError: ''
      },
      errorDescriptionDrawer: '',
      errorTestingDrawer: '',
      errorFullAnalystDrawer: '',
      timeLeft: 120,
      timerId: null,
      selectedLinkedControls: [],
      selectedLinkedControlsAsTarget: [],
      selectedLinkedControl: [],
      selectedAssessment: [],
      assessmentItems: [],
      assessmentControlItems: [],
      yesValueDoc: [],
      noValueDoc: [],
      selectedOptionsDoc: [],
      positiveAnswersDoc: [],
      negativeAnswersDoc: [],
      allAnswersCopyDoc: []
    }
  },
  props: {
    task: {},
    fromHomepage: {},
    controlObjective: {},
    // Open in the engagement task panel instead of the modal
    panel: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Datepicker,
    ConfirmRemoveAttachment,
    GuideViewModal,
    Avatar,
    ShowMoreModal,
    // draggable,
    CreateObservationModal,
    UserInviteModal,
    // AssessmentGlobalExpandable,
    ObservationViewModal,
    MeasuresTable,
    WordByWord,
    AssessmentGlobalSingleTaskModalHeader,
    AssessmentGlobalSingleTaskModalBody,
    AssessmentGlobalSingleTaskModalFooter,
    EngagementTaskPanel,
    AssessmentGlobalSingleTaskModalAuxModals,
    TaskDialog
  },
  provide() {
    return {
      assessmentSingleTask: this
    };
  },
  computed: {
    getClient() {
      return this.$store.state.client;
    },
    // Rejecting a task and completing a rejected task both need a comment for the QA log
    qaCommentMissing() {
      return !(this.qa_comment || '').trim();
    },
    getUser() {
      return this.$store.state.user;
    },
    requiredSignOffs() {
      let project = this.selectedTask ? this.selectedTask.project : null;
      return project && project.required_sign_offs ? parseInt(project.required_sign_offs, 10) : 0;
    },
    // Green only once the project's required number of sign-offs is reached (at least one)
    signOffReached() {
      let count = this.selectedTask && this.selectedTask.sign_off_count ? this.selectedTask.sign_off_count : 0;
      return count > 0 && count >= this.requiredSignOffs;
    },
    signOffProgress() {
      let count = this.selectedTask && this.selectedTask.sign_off_count ? this.selectedTask.sign_off_count : 0;
      return this.requiredSignOffs > 0 ? count + '/' + this.requiredSignOffs : count;
    },
    isCurrentSigner() {
      let signers = this.selectedTask && this.selectedTask.signers ? this.selectedTask.signers : [];
      return !!this.getUser && signers.some((signer) => signer.user_id == this.getUser.id);
    },
    getWordpressLink() {
      return this.$store.state.wordpressLink;
    },
    getReportMedia() {
      let media = [];

      if (this.selectedTask.project) {
        media = _.filter(this.selectedTask.project.media, function (mediaItem) {
          return mediaItem.collection_name == 'documents' || mediaItem.collection_name == 'project';
        });
      }


      return media;
    },
    getReportLinks() {
      let links = [];

      if (this.selectedTask.project) {
        links = _.filter(this.selectedTask.project.links, function (link) {
          return link.collection == null;
        });
      }

      return links;
    },
    formattedText() {
      // Replace newlines with <br><br> for HTML rendering
      return this.text.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
    },
    isControlAssessment() {
      return !!(this.selectedTask && this.selectedTask.project && this.selectedTask.project.type == 'control_assessment');
    },
    // Engagements (one time control assessments) use the evidence library for attachments
    isEngagementTask() {
      const project = this.selectedTask ? this.selectedTask.project : null;
      return !!project && project.type === 'control_assessment' && project.control_type === 'one time';
    },
    // Completed and closed projects are read-only until they are reopened
    projectLocked() {
      const project = this.selectedTask ? this.selectedTask.project : null;
      return !!project && (project.status === 'completed' || project.status === 'closed');
    },
    taskAdapter() {
      return projectAdapter(this.selectedTask.project);
    },
    // Why the task dialog can only be looked at: the project is locked or the task is finalized
    taskDialogLock() {
      if (this.projectLocked) {
        return this.$t('task_dialog.locks.project');
      }
      return this.readOnly ? this.$t('task_dialog.locks.task_completed') : '';
    },
    // Nothing on the task can be changed: it is finalized or its project is locked
    readOnly() {
      return !!this.selectedTask && (this.selectedTask.status === 'completed' || this.projectLocked);
    },
    // Dialogs of engagement tasks use the V2 look
    v2ModalClass() {
      return this.isEngagementTask ? 'task-modal v2-modal' : 'task-modal';
    },
    // The task has moved on from design and implementation (D&I) to operating effectiveness (OE) testing
    isInOeTesting() {
      return !!(this.selectedTask && this.selectedTask.test_phase === 'operating_effectiveness');
    },
    isMainTaskAssignee() {
      const user = this.$store.state.user;
      return !!(user && this.selectedTask && _.some(this.selectedTask.users || [], assignee => assignee.id === user.id));
    },
    // During OE testing users who are only documentation collection assignees can only work on tests
    dataCollectionLocked() {
      const user = this.$store.state.user;
      const isDataCollectionAssignee = !!(user && this.selectedTask && _.some(this.selectedTask.data_users || [], assignee => assignee.id === user.id));
      return this.isInOeTesting && isDataCollectionAssignee && !this.isMainTaskAssignee;
    },
    // Operating effectiveness testing is only used on type two projects
    usesOeTesting() {
      return this.isControlAssessment && !!this.selectedTask.project && this.selectedTask.project.project_type === 'type two';
    },
    canChangeTestPhase() {
      // Main task assignees and the project team can move a task between D&I and OE testing
      const user = this.$store.state.user;
      const projectUsers = (this.selectedTask.project && this.selectedTask.project.users) || [];
      const isTeamMember = !!(user && _.some(projectUsers, member => member.id === user.id));
      return this.isControlAssessment && !this.readOnly && (this.isMainTaskAssignee || isTeamMember);
    },
    // True when a field on the main task that is turned on (its add_ setting is anything
    // but "No" or empty) is open in edit mode. The documentation response belongs to the
    // documentation collection task and only shows on the main task when set to "Auditor".
    // Why Finalize task isn't possible yet (empty when it is). On engagements the conclusion must be
    // saved first and, with OE testing, every test must be passed or failed (with deviation). Some
    // controls need no samples, so a task in OE testing without tests can be finalized too.
    finalizeBlockedReason() {
      if (this.hasOpenTextFields) {
        return this.$t('tasks.modal.finalize_task_text_fields_open');
      }
      if (!this.isEngagementTask) {
        return '';
      }
      if (this.usesOeTesting) {
        const tests = this.tests || [];
        const open = _.filter(tests, test => test.status !== 'passed' && test.status !== 'failed').length;
        if (!this.isInOeTesting || open) {
          return this.$t('tasks.v2.finalize_needs_oe');
        }
      }
      if (!(this.selectedTask && this.selectedTask.remarks)) {
        return this.$t('tasks.v2.finalize_needs_conclusion');
      }
      return '';
    },
    hasOpenTextFields() {
      const task = this.selectedTask;
      if (!task) {
        return false;
      }
      const fields = [
        { setting: task.add_control_description, editMode: this.editModeControlDescription },
        { setting: task.add_performed_text, editMode: this.editModePerformedTest },
        { setting: task.add_testing_notes, editMode: this.editModeTestingNotes },
        { setting: task.add_description, editMode: this.editModeConclusion },
        { setting: task.add_notes, editMode: this.editModeNotes },
        { setting: task.add_response, editMode: this.editModeResponse }
      ];

      const textOrResponseOpen = fields.some(function (field) {
        return field.editMode && !!field.setting && field.setting != 'No';
      });

      return textOrResponseOpen || (task.add_response_doc == 'Auditor' && this.editModeResponseDocMain);
    },
  },
  watch: {
    getClient: function () {

    },
    includeScheduled: function () {
      this.loadCA();
    }
  },
  methods: {
    getModalRef(name) {
      if (this.$refs && this.$refs[name]) {
        return this.$refs[name];
      }
      if (this.$refs && this.$refs.auxModals && this.$refs.auxModals.$refs) {
        if (this.$refs.auxModals.$refs[name]) {
          return this.$refs.auxModals.$refs[name];
        }
        const childRefs = Object.values(this.$refs.auxModals.$refs);
        for (const child of childRefs) {
          if (child && child.$refs && child.$refs[name]) {
            return child.$refs[name];
          }
        }
      }
      if (this.$refs && this.$refs.footer && this.$refs.footer.$refs) {
        return this.$refs.footer.$refs[name];
      }
      // The task panel has its own footer with the QA and assignee dialogs
      const panel = this.$refs && this.$refs['task-modal'];
      if (panel && panel.$refs && panel.$refs.footer && panel.$refs.footer.$refs) {
        return panel.$refs.footer.$refs[name];
      }
      return null;
    },
    showModal(name) {
      const ref = this.getModalRef(name);
      if (ref && typeof ref.show === 'function') {
        ref.show();
      }
    },
    hideModal(name) {
      const ref = this.getModalRef(name);
      if (ref && typeof ref.hide === 'function') {
        ref.hide();
      }
    },
    handleType(value) {
      this.positiveAnswers = [];
      this.negativeAnswers = [];
      if (value && value.value === 'Dropdown' || value.value === 'System') {
        this.allAnswers = this.selectedOptions;
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      } else {
        this.noValue = this.answerTypes[0].items[0];
        this.yesValue = this.answerTypes[0].items[0];
        this.allAnswers = this.yesNoOptions;
        this.allAnswersCopy = _.cloneDeep(this.allAnswers);
      }
    },
    startCountdown() {
      // Clear any existing timer to allow it to be restarted
      if (this.timerId) {
        clearInterval(this.timerId);
      }

      this.timeLeft = 120;

      // Store a reference to the component's 'this'
      const self = this;

      this.timerId = setInterval(function () {
        if (self.timeLeft > 0) {
          self.timeLeft--;
        } else {
          clearInterval(self.timerId);
        }
      }, 1000);
    },
    toggleTestingDrawer(type) {
      const wasClosed = !this.isTestingDrawerOpen;

      this.ailoading = false;

      this.isControlDescriptionDrawerOpen = false;
      this.isFullAnalystDrawerOpen = false;

      this.errorTestingDrawer = '';
      this.aiUnreadAttachments = [];
      this.isTestingDrawerOpen = !this.isTestingDrawerOpen;

      if (wasClosed) {
        this.ailoading = true;
        this.startCountdown();
        let formData = new FormData();
        formData.append("task_id", this.selectedTask.id);
        formData.append("type", 'test_plan');

        piincHttp.post('openai/query', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(response => {
            this.testPlanAi = response.data.choices
            this.aiUnreadAttachments = response.data.unread_attachments || [];
            this.ailoading = false;
          })
          .catch(error => {
            console.error(error); // Handle the error
            this.errorTestingDrawer = error.status + ' ' + error.statusText;
            this.ailoading = false;
          });
      } else {
        this.testPlanAi = [];
      }

    },
    toggleControlDescriptionDrawer(type) {
      const wasClosed = !this.isControlDescriptionDrawerOpen;

      this.ailoading = false;

      this.isTestingDrawerOpen = false;
      this.isFullAnalystDrawerOpen = false;

      this.errorDescriptionDrawer = '';
      this.aiUnreadAttachments = [];
      this.isControlDescriptionDrawerOpen = !this.isControlDescriptionDrawerOpen;

      if (wasClosed) {
        this.ailoading = true;
        this.startCountdown();
        let formData = new FormData();
        formData.append("task_id", this.selectedTask.id);
        formData.append("type", 'control_description');

        piincHttp.post('openai/query', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(response => {
            this.controlDescriptionAi = response.data.choices
            this.aiUnreadAttachments = response.data.unread_attachments || [];
            this.ailoading = false;
          })
          .catch(error => {
            console.error(error); // Handle the error
            this.errorDescriptionDrawer = error.status + ' ' + error.statusText;
            this.ailoading = false;
          });
      } else {
        this.controlDescriptionAi = [];
      }
    },
    toggleFullAnalystDrawer(type) {
      const wasClosed = !this.isFullAnalystDrawerOpen;

      this.isControlDescriptionDrawerOpen = false;
      this.isTestingDrawerOpen = false;

      this.ailoading = false;
      this.errorFullAnalystDrawer = '';
      this.aiUnreadAttachments = [];
      this.isFullAnalystDrawerOpen = !this.isFullAnalystDrawerOpen;

      if (wasClosed) {
        this.ailoading = true;
        this.startCountdown();
        let formData = new FormData();
        formData.append("task_id", this.selectedTask.id);
        formData.append("type", 'full_analyst');

        piincHttp.post('openai/query', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then(response => {

            this.fullAnalystAi = response.data.choices
            this.aiUnreadAttachments = response.data.unread_attachments || [];
            this.ailoading = false;
          })
          .catch(error => {
            console.error(error); // Handle the error
            this.errorFullAnalystDrawer = error.status + ' ' + error.statusText;
            this.ailoading = false;
          });
      } else {
        this.fullAnalystAi = [];
      }

    },
    loadQaComments() {
      let self = this;
      this.qaComments = []
      this.loadingQaComments = true;

      piincHttp.get('tasks/' + this.selectedTask.id + '/comments', {
        params:
        {
          client: this.getClient.id,
          per_page: 100,
          sort: 'created_at',
          order: 'asc',
          types: 'accepted,rejected,completed'
        }
      }).then(function (response) {
        self.qaComments = []

        _.forEach(response.data.items, function (item) {
          self.qaComments.push(item);
        })

        self.loadingQaComments = false;
      }, function () {
      });
    },
    loadTests() {
      let self = this;

      this.loadingTests = true;
      piincHttp.get('tasks/' + this.selectedTask.id + '/tests', {
        params:
        {
          per_page: 100,
          sort: 'created_at',
          order: 'asc'
        }
      }).then(function (response) {
        self.tests = []

        _.forEach(response.data.items, function (item) {
          self.tests.push(item);
        })

        self.loadingTests = false;
      }, function () {
      });
    },
    loadTest(testId) {
      let self = this;
      piincHttp.get('tasks/' + this.selectedTask.id + '/tests/' + testId, {
      }).then(function (response) {
        self.selectedTest = response.data

      }, function () {
      });
    },
    showQaLog() {
      let self = this;
      self.loadQaComments();
      self.showModal('qa-log');
    },
    hideQaLog() {
      let self = this;
      self.hideModal('qa-log');
    },
    showReopenQaTask() {
      let self = this;
      self.qa_comment = '';
      self.showModal('reopen-qa-task');
    },
    hideReopenQaTask() {
      let self = this;
      self.hideModal('reopen-qa-task');
    },
    showReopenQaTaskComplete() {
      let self = this;
      self.qa_comment = '';
      self.showModal('reopen-qa-task-complete');
    },
    hideReopenQaTaskComplete() {
      let self = this;
      self.hideModal('reopen-qa-task-complete');
    },
    reOpenQaTask() {
      if (this.qaCommentMissing) {
        return;
      }
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        status: 'pending',
        qa_status: 'rejected',
        qa_comment: self.qa_comment
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
        self.$emit('reloadContent');
        self.hideModal('reopen-qa-task');
        self.loadQaComments()
      }, function (error) {

        self.buttonDisabled = false;
        self.error = error.data.message;

      })
    },
    completeOpenQaTask() {
      if (this.qaCommentMissing) {
        return;
      }
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        status: 'completed',
        qa_status: 'completed',
        qa_comment: self.qa_comment
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
        self.hideModal('reopen-qa-task-complete');

        self.taskCompleted = true;
        self.$store.commit('storeTaskToolbarState', false);
        self.$emit('reloadContent');
        self.hideTaskModal();
      }, function (error) {

        self.buttonDisabled = false;
        self.error = error.data.message;

      })
    },
    acceptQaTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        qa_status: 'accepted',
        qa_comment: 'accepted'
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
        self.$emit('reloadContent');
        self.hideTaskModal();
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    // Edit modals
    // The cog on the task opens the task dialog (US 9398)
    showEditQModal(object) {
      this.loadProjectObjectives();
      this.$refs.taskDialog.open(object);
    },
    loadProjectObjectives() {
      let self = this;
      // Without "client": the project filter is enough, and the client filter only fits projects
      piincHttp.get('project-control-objectives', { params: {
        project: this.selectedTask.project.id,
        per_page: 100
      }}).then(function (response) {
        self.projectObjectives = response.data.items;
      }, function () {});
    },
    // Show the saved task, with its files and links, and refresh the list behind it
    taskEdited() {
      let self = this;
      piincHttp.get('tasks/' + this.selectedTask.id).then(function (response) {
        self.selectedTask = response.data;
        self.allAnswers = self.selectedTask.response_type_options ? JSON.parse(self.selectedTask.response_type_options) : [];
        self.allAnswersDoc = self.selectedTask.response_type_options_doc ? JSON.parse(self.selectedTask.response_type_options_doc) : [];
      }, function () {});
      this.$emit('reloadContent');
    },
    createTestFormSubmit(evt) {
      let self = this;
      evt.preventDefault();
      self.buttonDisabled = false;

      let formData = new FormData();

      formData.append("name", self.testForm.name);
      formData.append("description", self.testForm.description);
      formData.append("status", 'pending');
      formData.append("allow_description", self.testForm.allow_description.value);
      formData.append("allow_attachment", self.testForm.allow_attachment.value);

      piincHttp.post('tasks/' + self.selectedTask.id + '/tests', formData).then(function () {
        self.loadTests();
        self.hideModal('create-test');
      }, function () {
      })
    },
    updateTestFormSubmit(evt) {
      let self = this;
      evt.preventDefault();
      self.buttonDisabled = false;

      let formData = new FormData();

      formData.append("name", self.testForm.name);
      formData.append("description", self.testForm.description);

      formData.append("allow_description", self.testForm.allow_description.value);
      formData.append("allow_attachment", self.testForm.allow_attachment.value);
      formData.append("_method", 'put');

      piincHttp.post('tasks/' + self.selectedTask.id + '/tests/' + this.selectedTest.id, formData).then(function () {
        self.loadTests();
        self.hideModal('update-test');
      }, function () {
      })
    },
    saveWithoutComplete(evt) {
      evt.preventDefault();
      this.updateSmallTestFormSubmit(false); // Pass flag if needed
    },
    completeSubmission(evt) {
      evt.preventDefault();
      // Mandatory answer and files must be there before the client completes the test
      this.error = '';
      if (this.selectedTest.allow_description === 'Mandatory' && !(this.testForm.description_data || '').trim()) {
        this.error += ' ' + this.$t('tasks.v2.test_answer_required');
      }
      if (this.selectedTest.allow_attachment === 'Mandatory' && !this.getTestMedia('documents').length) {
        this.error += ' ' + this.$t('tasks.v2.test_files_required');
      }
      if (this.error) {
        return;
      }
      this.updateSmallTestFormSubmit(true); // Pass flag if needed
    },
    // Engagements: the client's answer on a test is saved on its own, without changing the test's status
    saveTestAnswer() {
      this.buttonDisabled = true;
      this.error = '';
      piincHttp.put('tasks/' + this.selectedTask.id + '/tests/' + this.selectedTest.id, {
        description_data: this.testForm.description_data || ''
      }).then(response => {
        this.buttonDisabled = false;
        this.selectedTest = response.data;
        this.testForm.description_data = response.data.description_data;
        this.editModeTestAnswer = false;
        this.loadTests();
      }, error => {
        this.buttonDisabled = false;
        this.error = error.data && error.data.message ? error.data.message : '';
      });
    },
    discardTestAnswer() {
      this.testForm.description_data = this.selectedTest.description_data;
      this.editModeTestAnswer = false;
    },
    // The auditor sends a test back to the documentation collection user: the test is pending
    // again, so the client can answer and attach files; the comment tells them what is missing
    sendTestBack(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.testForm.status = _.find(this.testStatus, status => status.value === 'pending');
      this.updateSmallTestFormSubmit(false, true);
    },
    updateSmallTestFormSubmit(isComplete, sendBack) {
      let self = this;

      self.buttonDisabled = false;

      let formData = new FormData();

      formData.append("_method", 'put');

      // Also unlocks the files of a test the client completed and then reopened
      if (sendBack) {
        formData.append("send_back", 1);
      }

      if (isComplete) {
        formData.append("status", 'documentation_collection_completed');
      } else {
        if (self.testForm.status && self.testForm.status.value) {
          formData.append("status", self.testForm.status.value);
        } else {
          formData.append("status", 'pending');
        }
      }

      if (self.testForm.comment) {
        formData.append("comment", self.testForm.comment);
      }

      if (self.testForm.description_data) {
        formData.append("description_data", self.testForm.description_data);
      }


      piincHttp.post('tasks/' + self.selectedTask.id + '/tests/' + this.selectedTest.id, formData).then(function () {
        self.loadTests();
        self.hideModal('show-test');
      }, function () {
      })
    },
    confirmDeleteTest(object) {
      let self = this;
      piincHttp.delete('tasks/' + self.selectedTask.id + '/tests/' + object.id).then(function (response) {
        self.hideTestConfirmDeleteModal();
        self.loadTests();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('projects.delete.success'))
      }, function () { });
    },
    showTestCreateModal() {
      this.selectedTest = [];
      this.error = '';
      this.testForm.name = '';
      this.testForm.description = '';
      // A new test starts with an optional answer and optional files
      this.testForm.allow_description = _.find(this.allowTypes, { value: 'Optional' });
      this.testForm.allow_attachment = _.find(this.allowTypes, { value: 'Optional' });
      this.allow_description = [];
      this.allow_attachment = [];
      this.showModal('create-test');
    },
    showEditTestModal(test) {
      this.selectedTest = test;
      this.testForm.name = test.name;
      this.testForm.description = test.description;

      this.allow_description = [];
      if (test.allow_description) {
        this.testForm.allow_description = _.find(this.allowTypes, function (item) {
          return item.value === test.allow_description;
        });
      }
      this.allow_attachment = [];
      if (test.allow_attachment) {
        this.testForm.allow_attachment = _.find(this.allowTypes, function (item) {
          return item.value === test.allow_attachment;
        });
      }
      this.showModal('update-test');
    },
    openTestModal(test, type) {
      this.error = '';
      this.selectedTest = test;
      this.testForm.name = test.name;
      this.testForm.status = test.status;
      this.testForm.description = test.description;
      this.testForm.description_data = test.description_data;
      if (!this.testForm.description_data || !this.testForm.description_data.length) {

        if (this.currentView == 'data_collection' && (test.status == 'passed' || test.status == 'failed')) {
          this.editModeControlDescriptionDocumentationCollection = false;
        } else {
          this.editModeControlDescriptionDocumentationCollection = true;
        }

      } else {
        this.editModeControlDescriptionDocumentationCollection = false;
      }
      this.editModeTestAnswer = this.editModeControlDescriptionDocumentationCollection;

      this.testForm.comment = test.comment;
      this.testForm.type = type;
      this.status = [];
      if (test.status) {
        this.testForm.status = _.find(this.testStatus, function (item) {
          return item.value === test.status;
        });
      }
      this.allow_description = [];
      if (test.allow_description) {
        this.testForm.allow_description = _.find(this.allowTypes, function (item) {
          return item.value === test.allow_description;
        });
      }
      this.allow_attachment = [];
      if (test.allow_attachment) {
        this.testForm.allow_attachment = _.find(this.allowTypes, function (item) {
          return item.value === test.allow_attachment;
        });
      }

      this.showModal('show-test');
    },
    getMedia(type) {
      let media = [];
      if (type == 'task') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'documents';
        });
      }

      if (type == 'data_documents') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'data_documents';
        });
      }

      if (type == 'task_and_data_collection') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'documents' || mediaItem.collection_name == 'data_documents';
        });
      }

      if (type == 'question') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'question';
        });
      }

      if (type == 'data_collection') {
        media = _.filter(this.selectedTask.media, function (mediaItem) {
          return mediaItem.collection_name == 'data_collection';
        });
      }
      return media;
    },
    getTestMedia(type) {
      let media = [];

      if (this.selectedTest.media && type == 'documents') {
        media = _.filter(this.selectedTest.media, function (mediaItem) {
          return mediaItem.collection_name == 'documents';
        });
      }
      return media;
    },
    getDifference(endDate) {
      var moment = require('moment');
      let currentDate = moment();
      endDate = moment(endDate);
      let difference = endDate.diff(currentDate, 'days');
      return difference;
    },
    openGuide() {
      if (this.wpGuide && this.wpGuide.link) {
        window.open(this.wpGuide.link, '_blank');
      }
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function (object) {
        return object.scope == code && object.type == 'Task' && object.enabled;
      });
      return existingGuide;
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', {
        params:
        {
          per_page: 1,
          language: 'en',
          type: 'Task',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function (response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0]);
          piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function (response) {
            self.wpGuide = response.data;
          }, function () {
          });
        }
      }, function () {
      });
    },
    loadGuidesData(code) {
      let self = this;
      let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', {
        params:
        {
          per_page: 1,
          language: 'en',
          type: 'Task',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function (response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0]);
          piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function (response) {
            self.wpGuideData = response.data;
          }, function () {
          });
        }
      }, function () {
      });
    },
    loadGuidesSystem(code) {
      let self = this;
      let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', {
        params:
        {
          per_page: 1,
          language: 'en',
          type: 'Task',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function (response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0]);
          piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function (response) {
            self.wpGuideSystem = response.data;
          }, function () {
          });
        }
      }, function () {
      });
    },
    getLinks(type) {
      let links = [];
      if (type == 'task') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'task';
        });
      }

      if (type == 'question') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'question' || link.collection == null;
        });
      }

      if (type == 'data_documents') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'data_documents';
        });
      }

      if (type == 'task_and_data_collection') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'data_documents' || link.collection == 'task';
        });
      }

      if (type == 'data_collection') {
        links = _.filter(this.selectedTask.links, function (link) {
          return link.collection == 'data_collection';
        });
      }
      return links;
    },
    getReducedUsers(users) {
      let reducedUsers = [];
      if (users) {
        if (users.length > 3) {
          reducedUsers = _.cloneDeep(users);
          reducedUsers = reducedUsers.slice(0, 3);
        } else {
          reducedUsers = users;
        }
      }
      return reducedUsers;
    },
    getIcon(object) {
      let foundObject = {};
      let responseOptions = JSON.parse(object.response_type_options);
      foundObject = _.find(responseOptions, function (item) {
        return item.title === object.response;
      });

      if (foundObject) {
        return foundObject.value.value;
      } else {
        return '';
      }

    },
    getIconDoc(object) {
      let foundObject = {};
      let responseOptions = JSON.parse(object.response_type_options_doc);
      foundObject = _.find(responseOptions, function (item) {
        return item.title === object.response_doc;
      });

      if (foundObject) {
        return foundObject.value.value;
      } else {
        return '';
      }

    },
    showCreateLinkModal(object) {
      let self = this;
      this.error = '';
      this.buttonDisabled = false;

      this.showModal('add-link');
    },
    hideCreateLinkModal() {
      this.hideModal('add-link');
    },
    reloadUserList() {
      this.loadUsers();
    },
    loadUsers(query) {
      let self = this;

      this.buttonDisabled = true;

      piincHttp.get('users', {
        params:
        {
          client: this.getClient.id,
          keyword: query ? query : undefined,
          per_page: 100
        }
      }).then(function (response) {
        self.userList = response.data.items;
        self.buttonDisabled = false;
      }, function () {
      });
    },
    showReopenDataCollectionModal(object) {
      let self = this;
      this.comment = '';
      this.reopenError = '';

      this.selectedAssignUsers = [];

      this.loadUsers();

      _.forEach(self.selectedTask.data_users, function (user) {
        self.selectedAssignUsers.push(user);
      })

      this.showModal('reopen-task');
    },
    hideReopenDataCollectionModal() {
      this.selectedAssignUsers = [];
      this.hideModal('reopen-task');
    },
    loadComments(taskId) {
      let self = this;
      let taskActiveId = '';

      this.loadingComments = true;

      if (taskId) {
        taskActiveId = taskId;
      } else {
        taskActiveId = self.task.id;
      }
      piincHttp.get('tasks/' + taskActiveId + '/comments', {
        params:
        {
          client: this.getClient.id,
          per_page: 100,
          sort: 'id',
          order: 'asc'
        }
      }).then(function (response) {
        self.previousComments = [];

        self.previousComments = response.data.items.map(item => ({
          ...item,
          expanded: false
        }));

        self.loadingComments = false;
      }, function () {
      });
    },
    shouldShowAvatar(comment, index) {
      if (index === 0) return true; // always show for first message

      const previous = this.previousComments[index - 1];

      // Compare user IDs (preferred)
      return previous.user.id !== comment.user.id;
    },
    setTestPhase(phase) {
      let self = this;
      if ((phase || null) === (this.selectedTask.test_phase || null)) {
        return;
      }

      piincHttp.put('tasks/' + this.selectedTask.id, {
        test_phase: phase
      }).then(function() {
        self.loadTaskById(self.selectedTask.id, true);
        self.$toastr('success', self.$t('tasks.test_phase.update_success'));
      }, function(error) {
        self.$toastr('error', error.data && error.data.message ? error.data.message : '');
      });
    },
    addTaskAssignees(users) {
      let self = this;
      const userIds = _.uniq(_.map(this.selectedTask.users || [], 'id').concat(_.map(users, 'id')));

      return piincHttp.put('tasks/' + this.selectedTask.id, {
        users: userIds
      }).then(function() {
        self.loadTaskById(self.selectedTask.id, true);
        self.$toastr('success', self.$t('tasks.task_assignees.add_success'));
      });
    },
    addDataCollectionUsers(users) {
      let self = this;
      const userIds = _.uniq(_.map(this.selectedTask.data_users || [], 'id').concat(_.map(users, 'id')));

      return piincHttp.put('tasks/' + this.selectedTask.id, {
        data_users: userIds
      }).then(function() {
        self.loadTaskById(self.selectedTask.id, true);
        self.$toastr('success', self.$t('tasks.data_collection_assignees.add_success'));
      });
    },
    openUsersModal(object) {
      this.selectedItem = object;
      this.showUsersModal = true;
    },
    switchCurrentView(type) {
      this.showLinksSection = false;
      this.showDataCollectionLinksSection = false;
      this.loadComments();
      this.currentView = type;
      if (type == 'default') {
        this.loadGuides('assessment_task');
      } else {
        this.loadGuidesData('data_collection_task');
      }
    },
    showTaskModal(object) {
      let self = this;

      this.error = '';
      this.showLinksSection = false;
      this.showDataCollectionLinksSection = false;

      this.tests = [];
      this.sTableItems = [];
      this.previousComments = [];

      this.loadTaskById(object.id);

      if (object == null && this.tasks && this.tasks.length) {
        self.selectedTask = this.tasks[0];
      }

      // Checking the type of the users so the right view is displayed
      if (this.isOwner(self.selectedTask.project)) {
        // if the user is owner on the project od admin
        this.currentView = 'default';
      } else {
        // Checking the type of the users so the right view is displayed
        if (self.isOwner(self.selectedTask)) {
          self.switchCurrentView('default');
          if (self.selectedTask.code == 'update_measures') {
            self.loadGuidesSystem('system_description_task');
          } else {
            self.loadGuides('assessment_task');
          }
        } else {
          if (self.isDataOwner(self.selectedTask)) {
            self.switchCurrentView('data_collection');
            self.loadGuidesData('data_collection_task');
          }
        }
      }


      this.loadComments(object.id);


      this.showModal('task-modal');
      this.loadTaskGuide();

    },
    loadLinkedControls() {
      let self = this;

      this.buttonDisabled = false;

      piincHttp.get('projects/' + this.selectedTask.project.slug + '/tasks/linked', {
        params:
        {
          task_id: this.selectedTask.id,
          per_page: 100
        }
      }).then(function (response) {
        self.linkedControls = response.data;

        // Create an array to store all media files
        self.allLinkedMediaFiles = [];
        self.allLinkedDataMediaFiles = [];

        let existingLinkedMediaIds = (self.selectedTask.linked_media || []).map(media => media.id);

        self.linkedControls.forEach(task => {
          // Evidence library files are linked to the task (pivot collection data_documents = evidence)
          (task.linked_media || []).forEach(file => {
            const collection = file.pivot ? file.pivot.collection : null;
            const known = existingLinkedMediaIds.includes(file.id) || _.some(self.allLinkedMediaFiles, item => item.id === file.id);
            if (!known) {
              if (collection === 'data_documents') {
                self.allLinkedDataMediaFiles.push(file);
                self.allLinkedMediaFiles.push(file);
              } else if (collection === 'documents') {
                self.allLinkedMediaFiles.push(file);
              }
            }
          });

          if (task.media && task.media.length > 0) {
            // Filter media files by collection names and store them in respective arrays
            task.media.forEach(file => {
              if (!existingLinkedMediaIds.includes(file.id)) { // Check if media doesn't already exist in linked_media
                if (file.collection_name === 'data_documents') {
                  self.allLinkedDataMediaFiles.push(file);
                  self.allLinkedMediaFiles.push(file);
                } else if (file.collection_name === 'documents') {
                  self.allLinkedMediaFiles.push(file);
                }
              }
            });
          }
        });

        self.buttonDisabled = false;
      }, function () {
      });
    },
    hideTaskModal() {
      // Kept so the task can be opened again from the sidebar
      this.$store.commit('storeLastClosedTask', this.selectedTask);
      let self = this;
      this.error = '';

      this.editModeResponse = false;
      this.editModeResponseDoc = false;
      this.editModeResponseDocMain = false;
      this.editModeNotes = false;
      this.editModeControlDescription = false;
      this.editModePerformedTest = false;
      this.editModeTestingNotes = false;
      this.editModeConclusion = false;
      this.editModeControlDescriptionDocumentationCollection = false;

      this.taskForm.response = '';
      this.taskForm.notes = '';
      this.taskForm.control_description = '';
      this.taskForm.performed_text = '';
      this.taskForm.testing_notes = '';
      this.taskForm.remarks = '';
      this.taskForm.data_remarks = '';
      this.taskForm.rto = '';
      this.taskForm.rpo = '';
      this.selectedAnswer = [];
      this.selectedDate = '';
      this.selectedAnswerDoc = [];
      this.selectedDateDoc = '';
      this.selectedDataCollectionAnswer = [];

      setTimeout(function () {
        self.selectedTask = {};
      }, 500);

      if (this.taskCompleted) {
        self.$store.commit('storeReloadTasks');
      }

      this.hideModal('task-modal');
    },
    navigateToProject(task) {
      this.$store.commit('storeTaskToolbarState', true);
      this.$store.commit('storeActiveTask', task);
      this.$router.push({ name: 'projects.view', params: { slug: task.project.slug } });
    },
    populateForm() {
      let self = this;


      self.taskForm.remarks = self.selectedTask.remarks;
      self.taskForm.notes = self.selectedTask.notes;
      self.taskForm.control_description = self.selectedTask.control_description;
      self.taskForm.performed_text = self.selectedTask.performed_text;
      self.taskForm.data_remarks = self.selectedTask.data_remarks;
      self.taskForm.testing_notes = self.selectedTask.testing_notes;

      self.conflictBaseline = {
        updatedAt: self.selectedTask.updated_at,
        fields: {}
      };
      Object.keys(self.textFields()).forEach(function (field) {
        self.conflictBaseline.fields[field] = self.selectedTask[field];
      });
      if (self.selectedTask && self.selectedTask.response_type_options) {
        self.allAnswers = JSON.parse(self.selectedTask.response_type_options);
      } else {
        self.allAnswers = []
      }

      if (self.selectedTask && self.selectedTask.response_type_options_doc) {
        self.allAnswersDoc = JSON.parse(self.selectedTask.response_type_options_doc);
      } else {
        self.allAnswersDoc = []
      }


      self.selectedAnswer = [];
      if (self.selectedTask.response) {
        if (self.selectedTask.response_type != 'Datepicker') {
          self.selectedAnswer = _.find(self.allAnswers, function (item) {
            if (item.title === self.selectedTask.response) {
              return self.selectedTask.response;
            }
          });
        } else {
          self.selectedDate = self.selectedTask.response;
        }
      }

      self.selectedAnswerDoc = [];
      if (self.selectedTask.response_doc) {
        if (self.selectedTask.response_type_doc != 'Datepicker') {
          self.selectedAnswerDoc = _.find(self.allAnswersDoc, function (item) {
            if (item.title === self.selectedTask.response_doc) {
              return self.selectedTask.response_doc;
            }
          });
        } else {
          self.selectedDateDoc = self.selectedTask.response_doc;
        }
      }

      self.selectedDataCollectionAnswer = [];
      if (self.selectedTask.data_response) {
        self.selectedDataCollectionAnswer = _.find(self.allAnswers, function (item) {
          if (item === self.selectedTask.data_response) {
            return self.selectedTask.data_response;
          }
        });
      }

      if (!self.selectedAnswer.title && !self.selectedDate.length) {
        self.editModeResponse = true;
      }
      if (!self.selectedAnswerDoc.title && !self.selectedDateDoc.length) {
        self.editModeResponseDoc = true;
      }
      if (!self.selectedAnswerDoc.title && !self.selectedDateDoc.length) {
        self.editModeResponseDocMain = false;
      }
      if (!self.taskForm.notes || !self.taskForm.notes.length) {
        self.editModeNotes = true;
      }
      if (!self.taskForm.control_description || !self.taskForm.control_description.length) {
        self.editModeControlDescription = true;
      }
      if (!self.taskForm.performed_text || !self.taskForm.performed_text.length) {
        self.editModePerformedTest = true;
      }
      if (!self.taskForm.testing_notes || !self.taskForm.testing_notes.length) {
        self.editModeTestingNotes = true;
      }
      if (!self.taskForm.remarks || !self.taskForm.remarks.length) {
        self.editModeConclusion = true;
      }
      if (!self.taskForm.data_remarks || !self.taskForm.data_remarks.length) {
        self.editModeControlDescriptionDocumentationCollection = true;
      }

      this.selectedConfidentialityImpact = [];
      if (self.selectedTask.confidentiality) {
        self.selectedConfidentialityImpact = _.find(self.impactItems, function (item) {
          if (item.value === self.selectedTask.confidentiality) {
            return item;
          }
        });
      }

      this.selectedIntegrityImpact = [];
      if (self.selectedTask.integrity) {
        self.selectedIntegrityImpact = _.find(self.impactItems, function (item) {
          if (item.value === self.selectedTask.integrity) {
            return item;
          }
        });
      }

      this.selectedAvailabilityImpact = []
      if (self.selectedTask.availability) {
        self.selectedAvailabilityImpact = _.find(self.impactItems, function (item) {
          if (item.value === self.selectedTask.availability) {
            return item;
          }
        });
      }

      this.rtoInterval = []
      if (self.selectedTask.rto_type) {
        self.rtoInterval = _.find(self.intervalOptions, function (item) {
          if (item.value === self.selectedTask.rto_type) {
            return item;
          }
        });
      }

      this.rpoInterval = []
      if (self.selectedTask.rpo_type) {
        self.rpoInterval = _.find(self.intervalOptions, function (item) {
          if (item.value === self.selectedTask.rpo_type) {
            return item;
          }
        });
      }

      this.taskForm.rto = this.selectedTask.rto_number;
      this.taskForm.rpo = this.selectedTask.rpo_number;

      // The task panel decides which fields start in edit mode
      this.$emit('populated');
    },
    showViewGuideModal(object) {
      this.selectedGuide = object;
      this.viewGuideModal = true;
    },
    openWelcomePage() {
      this.showViewGuideModal(this.welcomeGuide);
    },
    showDropActiveFunction(value) {
      this.showDropActive = value;
    },
    loadTaskGuide() {
      let language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
      let self = this;
      piincHttp.get('guides', {
        params:
        {
          per_page: 1,
          language: 'en',
          type: 'Task',
          scope: 'assessment_task',
          client: this.getClient.slug
        }
      }).then(function (response) {
        if (response.data.items.length) {
          self.welcomeGuide = response.data.items[0];
        }
      }, function () {
      });
    },
    navigateToTask(object) {
      if (this.isOwner(object.model)) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        if (object.model_type == 'App\\Activity\\Models\\Activity') {
          this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id } });
        }
        if (object.model_type == 'App\\Process\\Models\\Process') {
          this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id } });
        }
        if (object.model_type == 'App\\System\\Models\\System') {
          this.$router.push({ name: 'systems.view', params: { slug: object.model.slug, }, query: { task: object.id } });
        }
        if (object.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          this.$router.push({ name: 'contracts.view', params: { slug: object.model.slug, }, query: { task: object.id } });
        }
      }
    },
    isOwner(object) {
      if (!object || !object.users) {

        return false;
      }
      let self = this;
      let allow = false;
      let existingUser = _.find(object.users, function (user) {
        return user.id == self.getUser.id;
      });


      if (existingUser) {
        allow = true;
      } else {
        if (roleCheck('Client admin') || roleCheck('Partition admin') || roleCheck('Validator') || this.getUser.isAdmin) {
          allow = true;
        }
      }

      return allow;
    },
    isDataOwner(object) {
      let self = this;
      let allow = false;
      let existingUser = _.find(object.data_users, function (user) {
        return user.id == self.getUser.id;
      });

      if (existingUser) {
        allow = true;
      } else {
        if (roleCheck('Client admin') || roleCheck('Partition admin') || roleCheck('Validator') || this.getUser.isAdmin) {
          allow = true;
        }
      }

      return allow;
    },
    isCommentOwner(object) {
      let self = this;
      let allow = false;
      let existingUser = object.user.id == this.getUser.id;

      if (existingUser) {
        allow = true;
      } else {
        if (this.getUser.isAdmin) {
          allow = true;
        }
      }

      return allow;
    },
    minimizeTask() {
      this.saveTask();
      var element = document.getElementsByClassName('modal');
      // Task panels aren't modals (US 9478)
      if (element.length) {
        element[0].classList.add("bottom-left");
      }
      // this.submitForm = true
      this.$store.commit('storeLastClosedTask', this.selectedTask);
    },
    addCommentSubmit() {
      let self = this;
      self.buttonDisabled = false;

      let formData = new FormData();

      formData.append("comment", self.comment);

      piincHttp.post('tasks/' + self.selectedTask.id + '/comments', formData).then(function () {
        self.loadTaskById(self.selectedTask.id, true);
        self.loadComments();
        self.showInput = false
        self.comment = '';
      }, function () {
      })
    },
    changeUsersSubmit() {
      let self = this;
      let userIds = [];

      if (this.selectedAssignUsers && this.selectedAssignUsers.length) {
        for (var i = 0; i < this.selectedAssignUsers.length; i++) {
          userIds.push(this.selectedAssignUsers[i].id);
        }
      }

      if (this.selectedAssignUsers && this.selectedAssignUsers.length) {
        piincHttp.put('tasks/' + self.selectedTask.id, {
          data_users: userIds
        }).then(function (response) {
          self.buttonDisabled = false;
          self.loadTaskById(self.selectedTask.id, true);
          self.hideReopenDataCollectionModal();
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.reopenError = '';
        self.buttonDisabled = false;
        if (this.selectedAssignUsers && !this.selectedAssignUsers.length) {
          this.reopenError += ' ' + this.$t('tasks.modal.recipient_error_message');
        }
      }
    },
    reopenFormSubmit() {
      this.buttonDisabled = true;
      let self = this;

      piincHttp.put('tasks/' + self.selectedTask.id, {
        data_status: 'pending',
      }).then(function (response) {
        self.buttonDisabled = false;
        self.loadTaskById(self.selectedTask.id, true);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })

    },
    completeTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      var moment = require('moment');
      let responseAnswer = '';
      let responseAnswerDoc = '';

      if (
        // -------------------------
        // Attachments
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_attachments === 'Mandatory' &&
            (
              (this.selectedTask.media && this.selectedTask.media.length) ||
              (this.selectedTask.links && this.selectedTask.links.length)
            )
          ) ||
          (this.selectedTask && this.selectedTask.add_attachments !== 'Mandatory')
        ) &&

        // -------------------------
        // Description
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_description === 'Mandatory' &&
            this.taskForm.remarks
          ) ||
          (this.selectedTask && this.selectedTask.add_description !== 'Mandatory')
        ) &&

        // -------------------------
        // Control description
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_control_description === 'Mandatory' &&
            this.taskForm.control_description
          ) ||
          (this.selectedTask && this.selectedTask.add_control_description !== 'Mandatory')
        ) &&

        // -------------------------
        // Notes
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_notes === 'Mandatory' &&
            this.taskForm.notes
          ) ||
          (this.selectedTask && this.selectedTask.add_notes !== 'Mandatory')
        ) &&

        // -------------------------
        // Performed text
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_performed_text === 'Mandatory' &&
            this.taskForm.performed_text
          ) ||
          (this.selectedTask && this.selectedTask.add_performed_text !== 'Mandatory')
        ) &&

        // -------------------------
        // MAIN response
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_response === 'Mandatory' &&
            (
              (this.selectedTask.response_type !== 'Datepicker' &&
                this.selectedAnswer &&
                this.selectedAnswer.title
              ) ||
              (this.selectedTask.response_type === 'Datepicker' &&
                this.selectedDate &&
                this.selectedDate !== ''
              )
            )
          ) ||
          (this.selectedTask && this.selectedTask.add_response !== 'Mandatory')
        ) &&

        // -------------------------
        // DOC response (NEW)
        // -------------------------
        (
          (this.selectedTask &&
            this.selectedTask.add_response_doc === 'Auditor' &&
            (
              (this.selectedTask.response_type_doc !== 'Datepicker' &&
                this.selectedAnswerDoc &&
                this.selectedAnswerDoc.title
              ) ||
              (this.selectedTask.response_type_doc === 'Datepicker' &&
                this.selectedDateDoc &&
                this.selectedDateDoc !== ''
              )
            )
          ) ||
          (this.selectedTask && this.selectedTask.add_response_doc !== 'Auditor')
        )
      ) {

        // -------------------------
        // Build MAIN response
        // -------------------------
        if (this.selectedTask.response_type !== 'Datepicker') {
          responseAnswer = this.selectedAnswer && this.selectedAnswer.title
            ? this.selectedAnswer.title
            : undefined;
        } else {
          responseAnswer = this.selectedDate
            ? moment(this.selectedDate).format('YYYY-MM-DD')
            : undefined;
        }

        // -------------------------
        // Build DOC response
        // -------------------------
        if (this.selectedTask.response_type_doc !== 'Datepicker') {
          responseAnswerDoc = this.selectedAnswerDoc && this.selectedAnswerDoc.title
            ? this.selectedAnswerDoc.title
            : undefined;
        } else {
          responseAnswerDoc = this.selectedDateDoc
            ? moment(this.selectedDateDoc).format('YYYY-MM-DD')
            : undefined;
        }

        let selectedMediaIds = this.selectedLinkedMedia.map(function (media) {
          return media.id;
        });

        let selectedDataMediaIds = this.selectedLinkedDataMedia.map(function (media) {
          return media.id;
        });

        // -------------------------
        // Submit
        // -------------------------
        piincHttp.put('tasks/' + this.selectedTask.id, {
          remarks: this.taskForm.remarks,
          control_description: this.taskForm.control_description,
          notes: this.taskForm.notes,
          testing_notes: this.taskForm.testing_notes,
          performed_text: this.taskForm.performed_text,
          response: responseAnswer,
          response_doc: responseAnswerDoc,
          status: 'completed',
          linked_media: selectedMediaIds,
          linked_data_media: selectedDataMediaIds
        }).then(function () {
          self.buttonDisabled = false;
          self.showNextTaskOrClose();
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        });

      } else {
        // -------------------------
        // Errors
        // -------------------------
        this.error = '';
        self.buttonDisabled = false;

        if (this.selectedTask.add_control_description === 'Mandatory' && !this.taskForm.control_description) {
          this.error += ' ' + this.$t('tasks.modal.control_description_error_message');
        }

        if (this.selectedTask.add_notes === 'Mandatory' && !this.taskForm.notes) {
          this.error += ' ' + this.$t('tasks.modal.notes_error_message');
        }

        if (this.selectedTask.add_performed_text === 'Mandatory' && !this.taskForm.performed_text) {
          this.error += ' ' + this.$t('tasks.modal.performed_test_error_message');
        }

        if (
          this.selectedTask.add_response === 'Mandatory' &&
          (
            !this.selectedAnswer ||
            !this.selectedAnswer.title
          )
        ) {
          this.error += ' ' + this.$t('tasks.modal.response_error_message');
        }

        // 🔴 DOC response error (NEW)
        if (
          this.selectedTask.add_response_doc === 'Auditor' &&
          (
            (this.selectedTask.response_type_doc !== 'Datepicker' &&
              (!this.selectedAnswerDoc || !this.selectedAnswerDoc.title)
            ) ||
            (this.selectedTask.response_type_doc === 'Datepicker' &&
              (!this.selectedDateDoc || this.selectedDateDoc === '')
            )
          )
        ) {
          this.error += ' ' + this.$t('maintenance.questions.create.response_type_error_message');
        }

        if (this.selectedTask.add_description === 'Mandatory' && !this.taskForm.remarks) {
          this.error += ' ' + this.$t('tasks.modal.conclusion_error_message');
        }

        if (
          this.selectedTask.add_attachments === 'Mandatory' &&
          (!this.selectedTask.media || !this.selectedTask.media.length) &&
          (!this.selectedTask.links || !this.selectedTask.links.length)
        ) {
          this.error += ' ' + this.$t('tasks.modal.attachments_error_message');
        }
      }
    },
    showNextTaskOrClose() {
      let self = this;

      if (self.taskList.length > 1) {
        let index = _.findIndex(self.taskList, function (o) {
          return o.id === self.selectedTask.id;
        });

        if (index < self.taskList.length - 1) {
          self.selectedTask = self.taskList[index + 1];
        } else {
          self.selectedTask = self.taskList[0];
        }

        self.taskList.splice(index, 1);
        self.loadTaskById(self.selectedTask.id);
      } else {
        self.taskCompleted = true;
        self.$store.commit('storeTaskToolbarState', false);
        self.$emit('reloadContent');
        self.hideTaskModal();
      }
    },
    // Control assessment tasks save each field on its own, so finalizing only sets the
    // status (the backend also completes the documentation collection task). Sending the
    // field values again here risks overwriting saved answers with an empty form.
    finalizeTask() {
      let self = this;
      const task = this.selectedTask;

      if (this.hasOpenTextFields) {
        return;
      }

      this.error = '';

      if (task.add_control_description === 'Mandatory' && !task.control_description) {
        this.error += ' ' + this.$t('tasks.modal.control_description_error_message');
      }
      if (task.add_notes === 'Mandatory' && !task.notes) {
        this.error += ' ' + this.$t('tasks.modal.notes_error_message');
      }
      if (task.add_performed_text === 'Mandatory' && !task.performed_text) {
        this.error += ' ' + this.$t('tasks.modal.performed_test_error_message');
      }
      if (task.add_response === 'Mandatory' && !task.response) {
        this.error += ' ' + this.$t('tasks.modal.response_error_message');
      }
      if (task.add_response_doc === 'Auditor' && !task.response_doc) {
        this.error += ' ' + this.$t('maintenance.questions.create.response_type_error_message');
      }
      if (task.add_description === 'Mandatory' && !task.remarks) {
        this.error += ' ' + this.$t('tasks.modal.conclusion_error_message');
      }
      if (
        task.add_attachments === 'Mandatory' &&
        (!task.media || !task.media.length) &&
        (!task.links || !task.links.length)
      ) {
        this.error += ' ' + this.$t('tasks.modal.attachments_error_message');
      }

      if (this.error) {
        return;
      }

      this.buttonDisabled = true;

      piincHttp.put('tasks/' + task.id, {
        status: 'completed'
      }).then(function () {
        self.buttonDisabled = false;
        self.showNextTaskOrClose();
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      });
    },
    // Closes a control assessment task without saving; its fields are saved one by one.
    closeTask() {
      this.$store.commit('storeTaskToolbarState', false);
      this.$emit('reloadContent');
      this.hideTaskModal();
    },
    reOpenTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        status: 'pending'
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    completeDataTask() {
      var moment = require('moment');
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      if (
        ((this.selectedTask && this.selectedTask.data_collection_add_attachments == 'Mandatory' && ((this.getMedia('data_documents') && this.getMedia('data_documents').length) || (this.getLinks('data_documents') && this.getLinks('data_documents').length))) ||
          (this.selectedTask && this.selectedTask.data_collection_add_attachments != 'Mandatory')) &&
        ((this.selectedTask && this.selectedTask.data_collection_add_description == 'Mandatory' && this.taskForm.data_remarks) ||
          (this.selectedTask && this.selectedTask.data_collection_add_description != 'Mandatory'))
      ) {
        piincHttp.put('tasks/' + this.selectedTask.id, {
          data_remarks: this.taskForm.data_remarks,
          data_status: 'completed'
        }).then(function (response) {
          self.buttonDisabled = false;
          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function (o) {
              return o.id == self.selectedTask.id
            });
            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1];
            } else {
              self.selectedTask = self.taskList[0];
            }
            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.$store.commit('storeTaskToolbarState', false);
            if (self.isOwner(self.selectedTask)) {
              self.currentView = 'default';
              self.loadTaskById(self.selectedTask.id);
            } else {
              self.hideTaskModal();
            }
            self.$emit('reloadContent');
          }
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        if (this.selectedTask.data_collection_add_description == 'Mandatory' && !this.taskForm.data_remarks) {
          this.error += ' ' + this.$t('tasks.modal.comment_error_message');
        }
        if ((this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getMedia('data_documents') && !this.getMedia('data_documents').length) && (this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getLinks('data_documents') && !this.getLinks('data_documents').length)) {
          this.error += ' ' + this.$t('tasks.modal.attachments_error_message');
        }

      }
    },
    saveDataTask() {
      var moment = require('moment');
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      if (
        ((this.selectedTask && this.selectedTask.data_collection_add_attachments == 'Mandatory' && ((this.getMedia('data_documents') && this.getMedia('data_documents').length) || (this.getLinks('data_documents') && this.getLinks('data_documents').length))) ||
          (this.selectedTask && this.selectedTask.data_collection_add_attachments != 'Mandatory')) &&
        ((this.selectedTask && this.selectedTask.data_collection_add_description == 'Mandatory' && this.taskForm.data_remarks) ||
          (this.selectedTask && this.selectedTask.data_collection_add_description != 'Mandatory'))
      ) {
        piincHttp.put('tasks/' + this.selectedTask.id, {
          data_remarks: this.taskForm.data_remarks
        }).then(function (response) {
          self.buttonDisabled = false;
          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function (o) {
              return o.id == self.selectedTask.id
            });
            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1];
            } else {
              self.selectedTask = self.taskList[0];
            }
            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.$store.commit('storeTaskToolbarState', false);
            if (self.isOwner(self.selectedTask)) {
              self.currentView = 'default';
              self.loadTaskById(self.selectedTask.id);
            } else {
              self.hideTaskModal();
            }
          }
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        if (this.selectedTask.data_collection_add_description == 'Mandatory' && !this.taskForm.data_remarks) {
          this.error += ' ' + this.$t('tasks.modal.comment_error_message');
        }
        if ((this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getMedia('data_documents') && !this.getMedia('data_documents').length) && (this.selectedTask.data_collection_add_attachments == 'Mandatory' && this.getLinks('data_documents') && !this.getLinks('data_documents').length)) {
          this.error += ' ' + this.$t('tasks.modal.attachments_error_message');
        }

      }
    },
    reOpenDataTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;

      piincHttp.put('tasks/' + this.selectedTask.id, {
        data_status: 'pending'
      }).then(function (response) {
        self.selectedTask = response.data;
        self.buttonDisabled = false;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    completeSystemRiskTask() {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      this.error = '';

      if (
        this.taskForm.remarks != '' &&
        this.selectedConfidentialityImpact && this.selectedConfidentialityImpact.value &&
        this.selectedIntegrityImpact && this.selectedIntegrityImpact.value &&
        this.selectedAvailabilityImpact && this.selectedAvailabilityImpact.value &&
        this.taskForm.rto != '' &&
        this.taskForm.rpo != '' &&
        this.rtoInterval && this.rtoInterval.value &&
        this.rpoInterval && this.rpoInterval.value
      ) {
        piincHttp.put('tasks/' + this.selectedTask.id, {
          remarks: this.taskForm.remarks,
          confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
          integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
          availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
          rto_number: this.taskForm.rto,
          rto_type: this.rtoInterval ? this.rtoInterval.value : '',
          rpo_number: this.taskForm.rpo,
          rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
          status: 'completed'
        }).then(function (response) {
          self.$toastr('success', self.$t('tasks.modal.success'));
          self.buttonDisabled = false;

          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function (o) {
              return o.id == self.selectedTask.id
            })
            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1];
            } else {
              self.selectedTask = self.taskList[0];
            }
            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.hideModal('task-modal');
          }
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        this.error = this.$t('tasks.modal.all_fields_error_message');
      }
    },
    saveTask() {
      var moment = require('moment');
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      let responseAnswer = '';
      let responseAnswerDoc = '';
      if (this.selectedTask.response_type != 'Datepicker') {
        responseAnswer = this.selectedAnswer && this.selectedAnswer.title ? this.selectedAnswer.title : '';
      } else {
        responseAnswer = this.selectedDate ? moment(this.selectedDate).format('YYYY-MM-DD') : '';
      }

      if (this.selectedTask.response_type_doc != 'Datepicker') {
        responseAnswerDoc = this.selectedAnswerDoc && this.selectedAnswerDoc.title ? this.selectedAnswerDoc.title : '';
      } else {
        responseAnswerDoc = this.selectedDateDoc ? moment(this.selectedDateDoc).format('YYYY-MM-DD') : '';
      }

      let selectedMediaIds = this.selectedLinkedMedia.map(media => media.id);
      let selectedDataMediaIds = this.selectedLinkedDataMedia.map(media => media.id);

      piincHttp.put('tasks/' + this.selectedTask.id, {
        data_remarks: this.taskForm.data_remarks,
        remarks: this.taskForm.remarks,
        performed_text: this.taskForm.performed_text,
        control_description: this.taskForm.control_description,
        notes: this.taskForm.notes,
        testing_notes: this.taskForm.testing_notes,
        confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
        integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
        availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
        rto_number: this.taskForm.rto,
        rto_type: this.rtoInterval ? this.rtoInterval.value : '',
        rpo_number: this.taskForm.rpo,
        rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
        response: responseAnswer,
        response_doc: responseAnswerDoc,
        data_response: this.selectedDataCollectionAnswer && this.selectedDataCollectionAnswer.length ? this.selectedDataCollectionAnswer : '',
        linked_media: selectedMediaIds,
        linked_data_media: selectedDataMediaIds
      }).then(function (response) {
        self.buttonDisabled = false;
        self.$emit('reloadContent', response.data);
        self.hideTaskModal();
        self.$toastr('success', self.$t('tasks.modal.success'))
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })

    },
    updateLinkedMedia() {
      let self = this;
      let selectedMediaIds = this.selectedLinkedMedia.map(media => media.id);

      piincHttp.put('tasks/' + this.selectedTask.id, {
        linked_media: selectedMediaIds,
      }).then(function (response) {
        self.loadTaskById(self.selectedTask.id, true);
        self.$emit('reloadContent', response.data);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    updateLinkedDataMedia() {
      let self = this;
      let selectedMediaIds = this.selectedLinkedDataMedia.map(media => media.id);

      piincHttp.put('tasks/' + this.selectedTask.id, {
        linked_data_media: selectedMediaIds,
      }).then(function (response) {
        self.loadTaskById(self.selectedTask.id, true);
        self.$emit('reloadContent', response.data);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    // Text fields that are saved one by one, with their edit mode flag and label
    textFields() {
      return {
        control_description: { editMode: 'editModeControlDescription', label: 'tasks.modal.control_description_label' },
        performed_text: { editMode: 'editModePerformedTest', label: 'tasks.modal.performed_test_label' },
        testing_notes: { editMode: 'editModeTestingNotes', label: 'tasks.modal.testing_notes_label' },
        notes: { editMode: 'editModeNotes', label: 'tasks.modal.notes_label' },
        remarks: { editMode: 'editModeConclusion', label: 'tasks.modal.remarks_label' },
        data_remarks: { editMode: 'editModeControlDescriptionDocumentationCollection', label: 'tasks.modal.comment_label' }
      };
    },
    // Fetches the task before saving so a change made by another user to the same field
    // isn't overwritten. If the field changed, the user picks which text to keep.
    saveTextField(field) {
      const self = this;
      const value = this.taskForm[field];

      piincHttp.get('tasks/' + this.selectedTask.id).then(function (response) {
        const latest = response.data;
        const taskUnchanged = latest.updated_at === self.conflictBaseline.updatedAt;

        if (!taskUnchanged && self.hasFieldConflict(field, value, latest)) {
          self.openFieldConflict(field, value, latest);
          return;
        }

        self.putTextField(field, value, taskUnchanged);
      }, function (error) {
        self.error = error.data.message;
      });
    },
    hasFieldConflict(field, value, latest) {
      const theirs = latest[field] || '';
      const loaded = this.conflictBaseline.fields[field] || '';

      return theirs !== loaded && theirs !== (value || '');
    },
    // Only moves the baseline timestamp on when nobody else changed the task in between,
    // otherwise their changes to other fields would no longer be detected.
    putTextField(field, value, advanceTimestamp) {
      const self = this;
      let data = {};
      data[field] = value;

      piincHttp.put('tasks/' + this.selectedTask.id, data).then(function (response) {
        self.selectedTask = response.data;
        self.conflictBaseline.fields[field] = value;
        if (advanceTimestamp) {
          self.conflictBaseline.updatedAt = response.data.updated_at;
        }
        self[self.textFields()[field].editMode] = false;
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      });
    },
    openFieldConflict(field, mine, latest) {
      this.fieldConflict = {
        field: field,
        mine: mine || '',
        theirs: latest[field] || '',
        theirsBy: latest.updatedBy && latest.updatedBy.name ? latest.updatedBy.name : '',
        theirsAt: latest.updated_at,
        merged: '',
        choice: 'mine',
        editMine: false,
        editMerged: false,
        mergeLoading: false,
        mergeError: ''
      };
      this.showModal('field-conflict');
    },
    generateMergedText() {
      const self = this;
      let formData = new FormData();
      formData.append('task_id', this.selectedTask.id);
      formData.append('type', 'merge_texts');
      formData.append('text_mine', this.fieldConflict.mine);
      formData.append('text_theirs', this.fieldConflict.theirs);

      this.fieldConflict.mergeLoading = true;
      this.fieldConflict.mergeError = '';

      piincHttp.post('openai/query', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(function (response) {
        const choices = response.data.choices;
        self.fieldConflict.merged = choices && choices.length ? choices[0].message.content.trim() : '';
        self.fieldConflict.choice = 'merged';
        self.fieldConflict.mergeLoading = false;
      }).catch(function (error) {
        self.fieldConflict.mergeError = error.status + ' ' + error.statusText;
        self.fieldConflict.mergeLoading = false;
      });
    },
    // Saves the chosen text. The other user's text now counts as seen, so the save runs the
    // conflict check again and only reopens the modal if the field changed once more.
    saveFieldConflict() {
      const conflict = this.fieldConflict;
      let text = conflict.mine;
      if (conflict.choice === 'theirs') {
        text = conflict.theirs;
      } else if (conflict.choice === 'merged') {
        text = conflict.merged;
      }

      this.taskForm[conflict.field] = text;
      this.conflictBaseline.fields[conflict.field] = conflict.theirs;
      this.hideModal('field-conflict');
      this.saveTextField(conflict.field);
    },
    // Leaves the field in edit mode with the user's own text, nothing is saved
    cancelFieldConflict() {
      this.hideModal('field-conflict');
    },
    updateControlDescription() {
      this.saveTextField('control_description');
    },
    discardControlDescription() {

      this.taskForm.control_description = this.selectedTask.control_description
      this.editModeControlDescription = false
    },
    updateDataRemarks() {
      this.saveTextField('data_remarks');
    },
    discardDataRemarks() {

      this.taskForm.data_remarks = this.selectedTask.data_remarks
      this.editModeControlDescriptionDocumentationCollection = false
    },
    updatePerformedTest() {
      this.saveTextField('performed_text');
    },
    discardPerformedTest() {

      this.taskForm.performed_text = this.selectedTask.performed_text
      this.editModePerformedTest = false
    },
    updateTestingNotes() {
      this.saveTextField('testing_notes');
    },
    discardTestingNotes() {

      this.taskForm.testing_notes = this.selectedTask.testing_notes
      this.editModeTestingNotes = false
    },
    updateNotes() {
      this.saveTextField('notes');
    },
    discardNotes() {

      this.taskForm.notes = this.selectedTask.notes
      this.editModeNotes = false
    },
    updateResponse() {
      const self = this;
      var moment = require('moment');
      let responseAnswer = '';
      if (this.selectedTask.response_type != 'Datepicker') {
        responseAnswer = this.selectedAnswer && this.selectedAnswer.title ? this.selectedAnswer.title : '';
      } else {
        responseAnswer = this.selectedDate ? moment(this.selectedDate).format('YYYY-MM-DD') : '';
      }

      piincHttp.put('tasks/' + this.selectedTask.id, {
        response: responseAnswer,
      }).then(function (response) {
        self.selectedTask = response.data;
        self.getIcon(response.data);
        // The task list shows the response, so it has to reload
        self.$emit('reloadContent', response.data);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeResponse = false
    },
    discardResponse() {
      const self = this;

      this.taskForm.response = this.selectedTask.response;

      if (self.selectedTask && self.selectedTask.response_type_options) {
        self.allAnswers = JSON.parse(self.selectedTask.response_type_options);
      } else {
        self.allAnswers = []
      }

      self.selectedAnswer = [];
      if (self.selectedTask.response) {
        if (self.selectedTask.response_type != 'Datepicker') {
          self.selectedAnswer = _.find(self.allAnswers, function (item) {
            if (item.title === self.selectedTask.response) {
              return self.selectedTask.response;
            }
          });
        } else {
          self.selectedDate = self.selectedTask.response;
        }
      }

      this.editModeResponse = false;
    },
    updateResponseDoc() {
      const self = this;
      var moment = require('moment');

      let responseAnswer = '';
      if (this.selectedTask.response_type_doc != 'Datepicker') {
        responseAnswer = this.selectedAnswerDoc && this.selectedAnswerDoc.title ? this.selectedAnswerDoc.title : '';
      } else {
        responseAnswer = this.selectedDateDoc ? moment(this.selectedDateDoc).format('YYYY-MM-DD') : '';
      }

      piincHttp.put('tasks/' + this.selectedTask.id, {
        response_doc: responseAnswer,
      }).then(function (response) {
        self.selectedTask = response.data;
        self.getIcon(response.data);
        self.$emit('reloadContent', response.data);
      }, function (error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
      this.editModeResponseDoc = false
      this.editModeResponseDocMain = false
    },
    discardResponseDoc() {
      const self = this;

      this.taskForm.response_doc = this.selectedTask.response_doc;

      if (self.selectedTask && self.selectedTask.response_type_options_doc) {
        self.allAnswers = JSON.parse(self.selectedTask.response_type_options_doc);
      } else {
        self.allAnswers = []
      }

      self.selectedAnswerDoc = [];
      if (self.selectedTask.response_doc) {
        if (self.selectedTask.response_type_doc != 'Datepicker') {
          self.selectedAnswerDoc = _.find(self.allAnswers, function (item) {
            if (item.title === self.selectedTask.response_doc) {
              return self.selectedTask.response_doc;
            }
          });
        } else {
          self.selectedDateDoc = self.selectedTask.response_doc;
        }
      }

      this.editModeResponseDoc = false;
      this.editModeResponseDocMain = false;
    },
    updateConclusion() {
      this.saveTextField('remarks');
    },
    discardConclusion() {
      this.taskForm.remarks = this.selectedTask.remarks;
      this.editModeConclusion = false;
    },

    openDeleteAttachmentModal(object) {
      this.selectedFile = object;
      this.showDeleteAttachmentModal = true;
    },
    openDeleteLinkedAttachmentModal(object) {
      this.selectedFile = object;
      this.showDeleteLinkedAttachmentModal = true;
    },
    openDeleteCommentModal(object) {
      this.selectedComment = object;
      this.showDeleteCommentModal = true;
    },
    handleLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLink.startsWith('http')) {
        this.inputLink = 'http://' + this.inputLink;
      }

      formData.append("url", this.inputLink);
      formData.append("name", this.inputLinkName);
      formData.append("collection", "task");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      piincHttp.post('links', formData).then(function () {
        self.inputLink = '';
        self.inputLinkName = '';
        self.hideCreateLinkModal();
        self.loadTaskById(self.selectedTask.id, true);
        self.showInput = false;
      }, function () {
      })
    },
    handleDataCollectionLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLink.startsWith('http')) {
        this.inputLink = 'http://' + this.inputLink;
      }

      formData.append("url", this.inputLink);
      formData.append("name", this.inputLinkName);
      formData.append("collection", "data_documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      piincHttp.post('links', formData).then(function () {
        self.inputLink = '';
        self.inputLinkName = '';
        self.loadTaskById(self.selectedTask.id, true);
        self.showDataCollectionLinksSection = false;
      }, function () {
      })
    },
    downloadMedia(object) {
      piincHttp.get('documents/' + object.id + '/download', {
        responseType: 'blob',
        params: {
          task: this.selectedTask.id
        }
      }).then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = object.file_name;

        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }, function () {
      });
    },
    loadTaskById(id, ignorePopulate) {
      let self = this;
      piincHttp.get('tasks/' + id).then(function (response) {
        self.selectedTask = response.data;
        if (self.isOwner(self.selectedTask)) {
          self.loadObservations(self.selectedTask.id);
        }
        self.loadLinkedControls();
        self.loadTests();
        self.loadQaComments();
        self.project_progress = self.selectedTask.project.user_progress.progress;
        if (!ignorePopulate) {
          self.populateForm();
          // Checking the type of the users so the right view is displayed
          if (self.isOwner(self.selectedTask)) {
            self.switchCurrentView('default');
            if (self.selectedTask.code == 'update_measures') {
              self.loadGuidesSystem('system_description_task');
            } else {
              self.loadGuides('assessment_task');
            }
          } else {
            if (self.isDataOwner(self.selectedTask)) {
              self.switchCurrentView('data_collection');
            }
          }
        }
      }, function () {
      });
    },
    onFileChangeEdit(file) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.files.length; i++) {
        // Equal to 10 MB
        if (this.files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.files[i].file);
      }

      formData.append("name", "documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      if (sizeError) {
        this.sizeError = this.$t('system.file_size_30');
        this.files = [];
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.error = '';
          self.sizeError = '';
          self.loadTaskById(self.selectedTask.id, true);
          self.files = [];
        }, function (error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0];
          }
        })
      }
    },
    onTestFileChange(file) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.test_files.length; i++) {
        // Equal to 10 MB
        if (this.test_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.test_files[i].file);
      }

      formData.append("name", "documents");
      formData.append("collection", "documents");
      formData.append("model_type", this.selectedTest.who_am_i);
      formData.append("model_id", this.selectedTest.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.test_files = [];
      } else {
        piincHttp
          .post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(() => {
            this.error = '';
            this.loadTest(this.selectedTest.id);
            this.test_files = [];
          })
          .catch((error) => {
            this.error = error.data.message;
            if (error.data.errors['document.0']) {
              this.error += ' ' + error.data.errors['document.0'][0];
            }
          });
      }
    },
    onDataFileChange(file) {
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.data_collection_files.length; i++) {
        // Equal to 10 MB
        if (this.data_collection_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.data_collection_files[i].file);
      }

      formData.append("name", "documents");
      formData.append("collection", "data_documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.data_collection_files = [];
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.error = '';
          self.loadTaskById(self.selectedTask.id, true);
          self.data_collection_files = [];
        }, function (error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0];
          }
        })
      }
    },
    loadObservations(task_id) {
      let self = this;

      // If page is not defined, set page to default 1
      let pageNumber = 1;

      this.loadingObservations = true;

      piincHttp.get('projects/' + self.selectedTask.project.slug + '/observations', {
        params:
        {
          page: pageNumber,
          client: this.getClient.slug,
          task_id: task_id
        }
      }).then(function (response) {
        if (response.data && response.data.items) {
          self.sTableItems = response.data.items;
        }
        // Set number of total items
        self.totalRows = response.data.total_count;
        self.loadingObservations = false;
      }, function () {
      });
    },
    deleteObservation(observation) {
      let self = this;

      self.loadingObservations = true;

      piincHttp.delete(
        'projects/' + self.selectedTask.project.slug + '/observations/' + observation.id
      )
        .then(function () {
          // Refresh the list after deletion
          self.loadObservations(self.selectedTask.id);
          self.hideSConfirmDeleteModal();
        })
        .catch(function (error) {
          console.error('Error deleting observation:', error);
          self.loadingObservations = false;
        });
    },
    showEditModal(object) {
      let self = this;
      this.error = '';
      this.selectedS = object

      this.editForm.name = object.name
      this.editForm.description = object.description

      if (this.selectedTask.project.type != 'control_assessment') {
        this.selectedScope = []
        if (object.scope && object.scope.id) {
          this.selectedScope = _.find(this.scopeItems, function (item) {
            return item.id === object.scope.id;
          });
        }
      } else {

      }

      this.selectedImpact = []
      if (object.impact_assessment) {
        this.selectedImpact = _.find(this.impactItems, function (item) {
          return item.value === object.impact_assessment;
        });
      }

      this.showModal('edit-observation')
    },
    editObservationFormSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      this.editForm.impact_assessment = this.selectedImpact ? this.selectedImpact.value : '';

      if (this.activity && this.activity.type == 'control_assessment') {
        if (this.selectedTask && this.selectedTask.id) {
          this.editForm.scope_id = this.selectedTask ? this.selectedTask.id : '';
        }
      } else {
        this.editForm.scope_id = this.selectedScope ? this.selectedScope.id : '';
      }

      if (this.selectedImpact && this.selectedImpact.value) {
        piincHttp.put('projects/' + this.$route.params.slug + '/observations/' + this.selectedS.id, this.editForm).then(function (response) {
          self.hideEditModal();
          self.loadObservations(self.selectedTask.id);
          self.$toastr('success', self.$t('projects.observations.update.success'))
          self.buttonDisabled = false;
        }, function (error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.users) {
              self.error += ' ' + error.data.errors.users[0]
            }
          }
        })
      } else {
        this.error = '';
        self.buttonDisabled = false;
        if (!this.selectedScope || (this.selectedScope && !this.selectedScope.id)) {
          this.error += this.$t('projects.observations.create.scope_error_message')
        }
        if (!this.selectedImpact || (this.selectedImpact && !this.selectedImpact.value)) {
          this.error += ' ' + this.$t('projects.observations.create.impact_error_message')
        }
      }
    },
    hideEditModal() {
      this.selectedS = {}
      this.hideModal('edit-observation')
    },
    hideEditTestModal() {
      this.selectedS = {}
      this.hideModal('create-test')
    },
    hideUpdateTestModal() {
      this.selectedS = {}
      this.hideModal('update-test')
    },
    hideShowTestModal() {
      this.selectedS = {}
      this.hideModal('show-test')
    },
    showSConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.showModal('delete-observation')
    },
    showTestConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.showModal('delete-test')
    },
    hideSConfirmDeleteModal() {
      this.itemToDelete = {}
      this.hideModal('delete-observation')
    },
    hideTestConfirmDeleteModal() {
      this.itemToDelete = {}
      this.hideModal('delete-test')
    },
    handleCloseViewModal() {
      this.loadObservations(this.selectedTask.id);
      this.viewObservationModal = false;
      this.selectedObservation = []
    },
    openViewModal(object) {
      this.selectedObservation = object
      this.viewObservationModal = true
    },
    onDragOver(event) {
      // Optional: You can handle visual cues when dragging over the area.
    },
    processFiles(fileList) {
      // Process the list of files
      for (let i = 0; i < fileList.length; i++) {
        this.files.push(fileList[i]);
      }

      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.files.length; i++) {
        // Equal to 10 MB
        if (this.files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.files[i]);
      }

      formData.append("name", "documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      if (sizeError) {
        this.sizeError = this.$t('system.file_size_30');
        this.files = [];
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.error = '';
          self.sizeError = '';
          self.loadTaskById(self.selectedTask.id, true);
          self.files = [];
        }, function (error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0];
          }
        })
      }

    },

    processFilesDocumentation(fileList) {
      // Process the list of files
      for (let i = 0; i < fileList.length; i++) {
        this.data_collection_files.push(fileList[i]);
      }

      let self = this;
      let formData = new FormData();
      let sizeError = false;

      // Append list of attachments to FormData
      for (var i = 0; i < this.data_collection_files.length; i++) {
        // Equal to 10 MB
        if (this.data_collection_files[i].size > 31457280) {
          sizeError = true;
        }
        formData.append("document[]", this.data_collection_files[i]);
      }

      formData.append("name", "documents");
      formData.append("collection", "data_documents");
      formData.append("model_type", this.selectedTask.who_am_i);
      formData.append("model_id", this.selectedTask.id);

      if (sizeError) {
        this.error = this.$t('system.file_size_30')
        this.data_collection_files = [];
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function () {
          self.error = '';
          self.loadTaskById(self.selectedTask.id, true);
          self.data_collection_files = [];
        }, function (error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0];
          }
        })
      }

    },
    onFileDrop(event) {
      // Handle the file drop, prevent default to stop the default behavior
    },
    handleDrop(event) {
      event.preventDefault(); // Prevent the default file-open behavior
      const files = event.dataTransfer.files; // Get the dropped files
      if (files.length) {
        this.processFiles(files); // Call a custom method to handle the files
      }
    },
    handleDropDocumentation(event) {
      event.preventDefault(); // Prevent the default file-open behavior
      const data_collection_files = event.dataTransfer.files; // Get the dropped files
      if (data_collection_files.length) {
        this.processFilesDocumentation(data_collection_files); // Call a custom method to handle the files
      }
    },
    hideDropActiveFunction() {
      // Handle when drop area becomes inactive
    },
  },
  created() {
    // this.loadTaskById(this.task.id);
  }
}
</script>
<style scoped>
.b-modal .modal-title {
  text-align: center;
  width: 100%;
  /* Ensures full width for proper centering */
  margin: 0 auto;
  /* Centers the title */
}
</style>
